// Категорії статусів:
// - initial: Початкові статуси (коло)
// - in_progress: В процесі (квадрат)
// - verification: Перевірки (ромб)
// - success: Успішні (коло з галочкою)
// - failed: Невдалі (коло з хрестиком)
// - paused: Призупинені (трикутник)

export type StatusShape =
  | 'circle'
  | 'square'
  | 'diamond'
  | 'circle-check'
  | 'circle-cross'
  | 'circle-dash'
  | 'triangle'

export interface StatusConfig {
  color: string
  shape: StatusShape
  filled: boolean // true = заповнена фігура, false = тільки обводка
}

export const statusConfigs: Record<string, StatusConfig> = {
  // Початкові статуси (коло)
  new: { color: '#3b82f6', shape: 'circle', filled: true }, // синє коло
  under_review: { color: '#3b82f6', shape: 'circle', filled: false }, // синє коло з обводкою

  // В процесі (квадрат)
  needs_clarification: { color: '#f97316', shape: 'square', filled: false }, // помаранчевий квадрат з обводкою
  interviewed: { color: '#06b6d4', shape: 'square', filled: true }, // блакитний квадрат

  // Перевірки (ромб)
  awaiting_polygraph: { color: '#8b5cf6', shape: 'diamond', filled: false }, // фіолетовий ромб з обводкою
  passed_polygraph: { color: '#22c55e', shape: 'diamond', filled: true }, // зелений ромб
  failed_polygraph: { color: '#ef4444', shape: 'diamond', filled: true }, // червоний ромб
  medical_check: { color: '#0ea5e9', shape: 'diamond', filled: false }, // блакитний ромб з обводкою

  // Успішні (коло з галочкою / заповнене коло)
  approved: { color: '#10b981', shape: 'circle-check', filled: true }, // зелене коло з галочкою
  documentation: { color: '#84cc16', shape: 'circle', filled: true }, // лаймове коло
  hired: { color: '#059669', shape: 'circle-check', filled: true }, // темно-зелене коло з галочкою

  // Невдалі (коло з рискою - В'їзд заборонено)
  rejected: { color: '#dc2626', shape: 'circle-dash', filled: true }, // червоне коло з білою рискою

  // Призупинені
  on_hold: { color: '#9ca3af', shape: 'circle', filled: false }, // сіре коло з обводкою
  archived: { color: '#6b7280', shape: 'circle', filled: true }, // темно-сірий заповнений кружок
}

export const statusLabels: Record<string, string> = {
  new: 'Нова',
  under_review: 'На розгляді',
  needs_clarification: 'Потребує уточнення',
  interviewed: 'Пройшов співбесіду',
  awaiting_polygraph: 'Очікує поліграф',
  passed_polygraph: 'Пройшов поліграф',
  failed_polygraph: 'Не пройшов поліграф',
  medical_check: 'Медична комісія',
  approved: 'Схвалено',
  documentation: 'Оформлення документів',
  hired: 'Прийнято на роботу',
  rejected: 'Відхилено',
  on_hold: 'Відкладено',
  archived: 'Архів',
}

// Для зворотної сумісності
export const statusColors: Record<string, string> = Object.fromEntries(
  Object.entries(statusConfigs).map(([key, config]) => [key, config.color]),
)

// Категорії для групування в select
export const statusCategories = [
  {
    label: 'Початкові',
    options: ['new', 'under_review'],
  },
  {
    label: 'В процесі',
    options: ['needs_clarification', 'interviewed'],
  },
  {
    label: 'Перевірки',
    options: ['awaiting_polygraph', 'passed_polygraph', 'failed_polygraph', 'medical_check'],
  },
  {
    label: 'Успішні',
    options: ['approved', 'documentation', 'hired'],
  },
  {
    label: 'Невдалі',
    options: ['rejected'],
  },
  {
    label: 'Призупинені',
    options: ['on_hold', 'archived'],
  },
]
